import {
  HTTP_METHODS,
  JWT_TOKEN_HEADER_KEY,
} from "../../../../../../Common/modules/DataProvider/constants/DataProvider.constants";
import { customRequest } from "../../../../../../Common/modules/DataProvider/utils/DataProvider.utils";
import { IOnboarding } from "../../../IOnboarding";
import {
  fetch_customer_details_api,
  update_customer_avatar_api,
} from "../constants/Customer.apis";

export const fetchCustomerDetails = (
  subDomain: string,
  accessToken?: string,
) => {
  return customRequest<IOnboarding.IFetchCustomerDetailsResponse>({
    endpoint: `${fetch_customer_details_api}?sub_domain=${subDomain}`,
    ...(accessToken
      ? {
          headers: {
            [JWT_TOKEN_HEADER_KEY]: accessToken,
          },
        }
      : {}),
  });
};

export const updateCustomerAvatar = (
  payload: IOnboarding.IUpdateCustomerAvatarPayload,
) => {
  return customRequest({
    endpoint: update_customer_avatar_api,
    method: HTTP_METHODS.POST,
    payload,
  });
};
